module.exports = __webpack_public_path__ + "static/img_2579-08fe9866cfaa765233a332637ca06869.webp";